import { DataProviderInstance } from '../../api/DataProvider';
import { useSubscription } from '../../contexts/SubscriptionContext';

/** Evento disparado depois da remoção: o App remonta a tela atual para ela recarregar. */
export const DEMO_DATA_REMOVED_EVENT = 'demoDataRemoved';

/** Linha com a marcação de exemplo (is_demo vem como 1, "1" ou true, conforme o endpoint). */
export const isDemoRecord = (record) => Boolean(record) && Number(record.is_demo) === 1;

/**
 * Estado dos dados de exemplo da conta de teste (docs/features/trial-demo-data).
 * active: a conta tem exemplo e ainda não removeu (CompanyConfig.DemoData, de get_company.php).
 * removable: active e em teste, a condição da faixa e do botão de remover (R5).
 */
export function useDemoData() {
  const { CompanyConfig } = DataProviderInstance();
  const { isInActiveTrial } = useSubscription();
  const demoData = CompanyConfig?.DemoData || null;
  const active = demoData?.active === true;
  return { demoData, active, removable: active && isInActiveTrial() };
}
